import { render, staticRenderFns } from "./AddRoommateDialog.vue?vue&type=template&id=4ab4b944&scoped=true&"
import script from "./AddRoommateDialog.vue?vue&type=script&lang=js&"
export * from "./AddRoommateDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddRoommateDialog.vue?vue&type=style&index=0&id=4ab4b944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4b944",
  null
  
)

export default component.exports